import { $isTableCellNode, $isTableNode, $isTableRowNode } from "@lexical/table";
import { $isRootNode } from "lexical";
import { $isDataTableCellNode } from "../nodes/data-table-cell-node";
import { $isDataTableNode } from "../nodes/data-table-node";

import type { DataTableNode } from "../nodes/data-table-node";
import type { LexicalNode } from "lexical";

export const $isInTableNode = (node: LexicalNode): boolean => {
  if ($isTableNode(node) || $isTableRowNode(node) || $isTableCellNode(node)) {
    return true;
  }

  const parent = node.getParent();
  if (!parent || $isRootNode(parent)) return false;

  return $isInTableNode(parent);
};

export const $isInDataTableNode = (node: LexicalNode): boolean => {
  if ($isDataTableNode(node) || $isDataTableCellNode(node)) {
    return true;
  }

  const parent = node.getParent();
  if (!parent || $isRootNode(parent)) return false;

  return $isInDataTableNode(parent);
};

export const findDataTableNode = (cellNode: LexicalNode): DataTableNode | null => {
  if ($isDataTableNode(cellNode)) {
    return cellNode;
  }

  const parent = cellNode.getParent();
  if (!parent || $isRootNode(parent)) return null;

  return findDataTableNode(parent);
};
